import fetchClient from './fetchClient';
import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getApiVersionInfo = async (): Promise<{
    data: any;
    error: any;
}> => {
    const res: any = await fetchClient.get(`/`, config()).catch(errorHandler);
    return res?.data;
};

export const getFile = async (
    name: string,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get(`/user/files?fileName=${name}`, config())
        .catch(() => {});
    return res;
};

export const getMyInfo = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient.get('/user/me', config()).catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const updateMyInfo = async (
    data: any,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .put('/user/', data, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const updateCompanyUser = async (
    id: string,
    data: any
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .put(`/user/accounts/${id}`, data, config())
        .catch(errorHandler);
    if (res?.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const uploadCompanyLogo = async (
    data: any,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .post(`/user/upload`, data, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getDashboardAnalytics = async (
    startDate: string,
    endDate: string,
    assignedTo?: string,
) => {
    const qs = new URLSearchParams();
    qs.set('startDate', String(startDate));
    qs.set('endDate', String(endDate));
    if (assignedTo) qs.set('assignedTo', assignedTo);
    const res: any = await fetchClient
    .get(`/user/dashboard?${qs.toString()}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getDashboardAnalyticsV2 = async (params?: { assignedTo?: string }) => {
    const qs = params?.assignedTo ? `?assignedTo=${encodeURIComponent(params.assignedTo)}` : '';
    const res: any = await fetchClient
        .get(`/user/dashboard/v2${qs}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getUsersLight = async () => {
    const res: any = await fetchClient.get(`/user/accounts`, config()).catch(() => null);
    if (!res) return null;
    const arr = res.data?.data || res.data || [];
    return arr.map((u: any) => ({
      _id: u._id || u.id,
      fullName: u.fullName || u.name || u.email || 'Utilisateur',
      email: u.email,
    }));
  };

export const getInactiveCustomers = async (days: number = 14): Promise<{
    data: any;
    error: any;
}> => {
    const res: any = await fetchClient
        .get(`/user/dashboard/inactive-customer?days=${days}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getCompanyAccounts = async (): Promise<{
    data: any;
    error: any;
}> => {
    const res: any = await fetchClient
        .get(`/user/accounts`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getPermissions = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get(`/user/permissions`, config())
        .catch(errorHandler);
    if (res?.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const createCompanyUser = async (data: any) => {
    const res: any = await fetchClient
        .post(`/user/accounts`, data, config())
        .catch(() => {
            return false;
        });
    if (!res) return false;
    return true;
};

export const deleteCompanyUser = async (id: string) => {
    const res: any = await fetchClient
        .delete(`/user/accounts/${id}`, config())
        .catch(() => {
            return false;
        });
    if (!res) return false;
    return true;
};

export const updateCompanyUserPermissions = async (
    id: string,
    permissions: any,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .put(`/user/accounts/${id}/permissions`, { permissions }, config())
        .catch(errorHandler);
    if (res?.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const updatePassword = async (
    data: any,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .put('/user/password', data, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};
